<script>
    import Picture from '$lib/components/Picture.svelte';

    export let content = {};
    export let modulePosition;
    export let sectionPosition;

    // Grid Layout
    let gridLayout = '';
    let gridLayoutPrimary = '';
    let gridLayoutSecondary = '';
    let imageSizes = [];
    let imageSizesSmall = [];
    switch (content?.imageCount) {
        case 1:
            gridLayout = 'w-full lg:col-span-12';
            imageSizes = [640, 1024, 1300];
            break;
        case 2:
            gridLayout = 'w-11/12 lg:col-span-6 lg:w-full';
            imageSizes = [400, 500, 650];
            break;
        case 3:
            gridLayoutPrimary = 'w-11/12 lg:col-span-8 lg:row-span-2 lg:w-full';
            gridLayoutSecondary = 'w-11/12 lg:col-span-4 lg:row-span-1 lg:w-full';
            imageSizes = [400, 650, 850];
            imageSizesSmall = [400, 350, 450];
            break;
        case 4:
            gridLayout = 'w-11/12 lg:col-span-6 lg:w-full';
            imageSizes = [400, 500, 650];
            break;
        default:
            gridLayout = '';
            break;
    }

    // Style
    let imageStyle = '';
    switch (content?.style) {
        case 'None':
            imageStyle = '';
            break;
        case 'Framed':
            imageStyle = 'w-full rounded-2xl shadow-xl';
            break;
        default:
            imageStyle = 'w-full rounded-2xl shadow-xl';
            break;
    }
</script>

<div
    class="no-scrollbar flex flex-nowrap gap-x-2 overflow-scroll lg:grid lg:grid-cols-12 lg:gap-x-4 lg:gap-y-3 lg:overflow-visible"
    data-moduleposition={modulePosition}
>
    {#each content?.images as image, index (image)}
        <svelte:element
            this={image?.link?.url ? 'a' : 'div'}
            class={`flex-none ${gridLayout} ${index === 0 ? gridLayoutPrimary : gridLayoutSecondary}`}
            href={image?.link?.url}
            title={image?.link?.title}
            target={image?.link?.newWindow ? '_blank' : null}
        >
            <Picture
                src={image?.url}
                alt={image?.alt}
                width={image?.dimensions?.width}
                height={image?.dimensions?.height}
                imageSizes={content?.imageCount === 3 ? (index === 0 ? imageSizes : imageSizesSmall) : imageSizes}
                classes={imageStyle}
                lazy={sectionPosition > 3}
                lcp={index === 0 && sectionPosition <= 3}
                lqip={image?.lqip}
            />
        </svelte:element>
    {/each}
</div>
